import React, { Component } from "react";
import axios from "../../../../axios-order";
import Grid from "@material-ui/core/Grid";
import CustomTable from "../../../../components/ui/Table/Table";
import { ValidatorForm } from "react-material-ui-form-validator";
import InputField from "../../../../components/ui/inputField";

class OrigaBatchList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      invoiceCol: [
        { key: "ifsc_code" },
        { key: "batch_id" },
        { key: "invoice_no" },
        { key: "invoice_date" },
        { key: "due_date" },
        { key: "cust_gstin" },
        { key: "cust_legal_name" },
        { key: "cust_pan" },
      ],
      oldInvoiceData: [],
      invoiceData: [],
      total_records: 0,
      invoiceHeader: [
        { label: "IFSC Code" },
        { label: "Batch ID" },
        { label: "Invoice No" },
        { label: "Invoice Date" },
        { label: "Due Date" },
        { label: "GSTIN" },
        { label: "Customer Name" },
        { label: "PAN" },
      ],
      bank: "",
      bankData: [],
      searchInput: "",
    };
    this.handleBankChange = this.handleBankChange.bind(this);
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
  }

  componentDidMount() {
    axios
      .get(
        "/origa/get_invoice_collections/" +
          localStorage.getItem("business_entity_id")
      )
      .then((res) => {
        this.setState({
          oldInvoiceData: res.data.data,
          invoiceData: res.data.data,
          total_records: res.data.data.length,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get("/get_banks/" + localStorage.getItem("business_entity_id"))
      .then((res) => {
        this.setState({
          bankData: res.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  handleBankChange(event) {
    let value = event.target.value;
    this.setState({
      bank: value,
    });
  }

  handleSearchInputChange = (event) => {
    const search_value = String(event.target.value).toLowerCase();
    this.setState({
      searchInput: search_value,
    });
    if (search_value !== "") {
      if (this.state.oldInvoiceData.length) {
        let invoiceDataNew = this.state.oldInvoiceData.filter((value) => {
          return (
            String(value.invoice_no).toLowerCase().indexOf(search_value) >= 0 ||
            String(value.cust_legal_name).toLowerCase().indexOf(search_value) >=
              0 ||
            String(value.cust_gstin).toLowerCase().indexOf(search_value) >= 0
          );
        });
        this.setState({
          invoiceData: invoiceDataNew,
        });
      }
    } else {
      this.setState({
        invoiceData: this.state.oldInvoiceData,
      });
    }
  };

  onSubmitHandler() {
    let selected_ids = [];

    let bank = this.state.bank;

    let selected_input = document.querySelectorAll(
      "input[name='invoices[]'][type=checkbox]:checked"
    );

    Object.keys(selected_input).map((v, i) => {
      selected_ids.push(selected_input[v].value);
    });
    axios
      .post("/origa/post_invoice_collections", {
        bank: bank,
        selected_ids: selected_ids,
        business_entity_id: localStorage.getItem("business_entity_id"),
      })
      .then((res) => {})
      .catch((error) => {});
  }

  render() {
    return (
      <React.Fragment>
        <div style={{ height: "300", margin: "20px 30px 0px 30px" }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <ValidatorForm
                ref="form"
                // onSubmit={this.onSubmitHandler}
                // onError={(errors) => console.log(errors)}
              >
                <InputField
                  textLabel="Search By Invoice"
                  inputType="text"
                  name="Search_by_customer_name"
                  value={this.state.searchInput ?? ""}
                  textOnchangeFunction={this.handleSearchInputChange}
                />
              </ValidatorForm>
            </Grid>
          </Grid>
        </div>
        {/* datatable component */}
        <div style={{ height: "300", margin: "20px 30px 0px 30px" }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <CustomTable
                headers={this.state.invoiceHeader}
                columns={this.state.invoiceCol}
                data={this.state.invoiceData}
                name="invoices"
              />
            </Grid>
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

export default OrigaBatchList;
